/**
 * GWH Sticky Add-to-Cart — show bar when buy buttons leave the viewport.
 */
(function () {
  function initStickyCart(root) {
    const addBtn = root.querySelector('[data-gwh-sticky-add]');
    const buyButtons =
      document.querySelector('.product-details .buy-buttons-block') ||
      document.querySelector('.product-details .buy-buttons');

    if (!buyButtons) return;

    function setVisible(show) {
      root.hidden = !show;
      root.setAttribute('aria-hidden', show ? 'false' : 'true');
      root.classList.toggle('is-visible', show);
      document.body.classList.toggle('gwh-sticky-cart-active', show);
    }

    function updateVisibility() {
      const rect = buyButtons.getBoundingClientRect();
      const headerOffset = 72;
      const pastBuy = rect.bottom < headerOffset;
      setVisible(pastBuy);
    }

    addBtn?.addEventListener('click', () => {
      const mainAdd = document.querySelector(
        '.product-details button[name="add"], .product-details .add-to-cart-button'
      );
      if (mainAdd && !mainAdd.disabled) {
        mainAdd.click();
        return;
      }
      buyButtons.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);
    updateVisibility();
  }

  function init() {
    document.querySelectorAll('[data-gwh-sticky-cart]').forEach(initStickyCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
